import React from "react";
import DataTable from "react-data-table-component";
import { companyProfile, problemType } from "../../../api";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import ModalChangePlant from "./modal/changePlant";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import { useAuth } from "../../../contexts/AuthContext.jsx";
import { PermissionChecker } from "../../../components/PermissionChecker";



function groupProblemTypesByLevel(problemTypes) { 
  const grouped = [];

  function traverse(nodes, level = 0,parent_name = "") {
    if (!nodes || nodes.length === 0) return;

    // Ensure this level array exists
    if (!grouped[level]) grouped[level] = [];

    for (const node of nodes) {
      // Add current node to its level group
      node.full_path = parent_name ? parent_name + " - " + node.problem_type_name : node.problem_type_name;
      grouped[level].push(node);
      // Recursively process sublocations
      traverse(node.subproblem_types, level + 1, node.full_path);
    }
  }
  traverse(problemTypes);
  return grouped;
}
function ProblemTypeTab({selectedIndex,onGrouped}) {

  const [openModal, setOpenModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selected, setSelected] = useState(false);
  const [filteredCompany, setFilteredCompany] = useState(null);
  const [problemTypes, setProblemTypes] = useState([]);
  const [filteredProblemTypes, setFilteredProblemTypes] = useState([]);
  const [parentProblemTypes, setParentProblemTypes] = useState([]);
  const [selectedParentProblemType, setSelectedParentProblemType] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [deleteRow, setDeleteRow] = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(false);  
  const { config } = useAuth();
  const problemType_wording = config.problem_type_wording.split(",");

  const clickAdd = () => {
    setOpenModal(true);
    setEditMode(false);
  };
 
  async function getProblemType(filteredParentProblemType) {
    try {
      const res = await problemType.list("", true);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setProblemTypes([]);
        if (data.length) {
          
          const grouped = groupProblemTypesByLevel(data);
          onGrouped(grouped);

        
            if (selectedIndex > 0) {


              setProblemTypes(grouped[selectedIndex]||[]);
              setParentProblemTypes(grouped[selectedIndex - 1]||[]);
              
              if(filteredParentProblemType) {
                setFilteredProblemTypes((grouped[selectedIndex] ||[]).filter((i) => i.parent_problem_type_id ===   filteredParentProblemType));
                }
                else {
                  setFilteredProblemTypes(grouped[selectedIndex]||[]);
                }
           
            
            } else {
              
              setProblemTypes(grouped[selectedIndex]||[]);
              setFilteredProblemTypes(grouped[selectedIndex]||[]);    
  
            } 
         
         
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  useEffect(() => {
    setSelectedParentProblemType(null);
    getProblemType(null);
  
  }, [selectedIndex]);



  const onSubmitted = () => {
    getProblemType(selectedParentProblemType);
  };
  const editProfile = (row) => {
    setSelected(row);
    setOpenModal(true);
    setEditMode(true);
  };
  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  const onChangeParentProblemType = (e) => {
    setSelectedParentProblemType(e.target.value);
    if(e.target.value) {
    setFilteredProblemTypes(problemTypes.filter((i) => i.parent_problem_type_id === e.target.value));
    }
    else {
      setFilteredProblemTypes(problemTypes);
    }
  };
    async function deleteProblemType() {
    try {
      const response = await problemType.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();

        if (body.success) {
          toast.success(
            `This ${problemType_wording[selectedIndex]} has been deleted`
          );
          setConfirmDlg(false);
          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }

        getProblemType(selectedParentProblemType);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  return (
    <>
      <div p={5} className="widget" style={{ height: "auto" }}>
        <div className="widget-wrapper" />
        <ModalChangePlant
          selected={selected}
          openModal={openModal}
          setOpenModal={setOpenModal}
          editMode={editMode}
          title={
            (editMode ? "Edit" : "Add") +
                ` ${problemType_wording[selectedIndex]}`
          }
          onSubmitted={onSubmitted}
          selectedIndex={selectedIndex}
            parentProblemTypes={parentProblemTypes}
        />
        <div style={{ position: "relative" }}>
          <div className="row">
           
            <div className={"col-sm-12"}>
              <div
                style={{
                  width: "auto",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >


               {selectedIndex != 0 && (
<div>
                  <select
                    className={"form-select btn btn-sm btn-outline-theme "}
                    value={selectedParentProblemType || ""}
                    onChange={onChangeParentProblemType}
                    style={{ minWidth: "200px" }}
                  >
                    <option value={""}>
                      - Select {problemType_wording[selectedIndex-1]} -
                    </option>
                    {parentProblemTypes.map((i, index) => (
                      <option key={index} value={i.id}>
                        {i.full_path}
                      </option>
                    ))}
                  </select>
                </div>
               )
              }
                <PermissionChecker
                  permissions={["create service group"]}
                  hideIfNotAllowed
                >
                  <button
                    className="btn btn-outline-theme btn-sm mb-2"
                    style={{ marginLeft: "10px", cursor: "pointer",minWidth: "200px" }}
                    onClick={clickAdd}
                  >
                    Add {problemType_wording[selectedIndex]}
                  </button>
                </PermissionChecker>
              </div>
            </div>
          </div>

          <div mt={2}>
            <DataTable
              highlightOnHover
              theme="dark"
              pagination
              columns={[
                {
                  name: "No",
                  width: "80px",
                  center: true,
                  cell: (_row, index) => index + 1,
                },
                {
                  name: problemType_wording[selectedIndex],
                  selector: (row) => row.problem_type_name,
                  
                  wrap: true,
                },
                {
                  name: "Actions",
                  width: "220px",
                  center: true,
                  cell: (row) => (
                    <div className="d-flex justify-content-center gap-2">
                      <PermissionChecker
                        permissions={["edit service group"]}
                        hideIfNotAllowed
                      >
                        <button
                          onClick={() => {
                            editProfile(row);
                          }}
                          className="btn btn-outline-theme btn-sm"
                        >
                          Edit
                        </button>
                      </PermissionChecker>
                      <PermissionChecker
                        permissions={["delete service group"]}
                        hideIfNotAllowed
                      >
                        <button
                          onClick={() => {
                            showConfirmationDlg(row);
                          }}
                          className="btn btn-outline-danger btn-sm"
                        >
                          Delete
                        </button>
                      </PermissionChecker>
                    </div>
                  ),
                },
              ]}
              data={filteredProblemTypes}
              keyField="id"
              noDataComponent={`No ${problemType_wording[selectedIndex]} found`}
            />
          </div>
        </div>
      </div>
      {deleteRow && (
        <ConfirmationDlg
          title={`Delete ${problemType_wording[selectedIndex]}`}
          open={confirmDlg}
          onClose={hideConfirmationDialog}
          onSubmit={deleteProblemType}
        >
          <div style={{ pb: 2 }}>
            Are you sure you want to delete this{" "}
            {problemType_wording[selectedIndex]}{" "}
            <strong>{deleteRow.name}</strong> ?
          </div>
        </ConfirmationDlg>
      )}
    </>
  );
}

export default ProblemTypeTab;
